module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-firma-circle-603b4008bd5ec000b50e3009bc04cffc.svg";